import React from "react";
import Lottie from "lottie-react";
import Animation from "./loader.json";

const style = { width: "100px", height: "100px" };

const Loader = () => (
  <Lottie style={style} animationData={Animation} loop={true} />
);

export default Loader;
